import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AswContextStoreService, AswMasterService, CommonLibService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { CprResultStoreService } from '@common/services/cpr-result-store/cpr-result-store.service';
import { GetOrderResultStoreService } from '@common/services';
import { DeviceType } from '@lib/interfaces';
import { Router } from '@angular/router';
import { CHECKIN_ROUTES } from '@conf/routes.config';

@Component({
  selector: 'asw-checkin-standby-review-sub-header',
  templateUrl: './checkin-standby-review-sub-header.component.html',
  styleUrls: ['./checkin-standby-review-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CprResultStoreService, GetOrderResultStoreService],
})
export class CheckinStandbyReviewSubHeaderComponent extends CheckinBaseComponent {
  /** 戻り先URL */
  backUrl = '';

  /** ブレッドクラムのステップ数保持のための変数 */
  public stepNum = 3;
  public currentStepNum = 2;

  constructor(
    private common: CommonLibService,
    private cprResultStoreService: CprResultStoreService,
    private getOrderResultStoreService: GetOrderResultStoreService,
    private _aswMasterSvc: AswMasterService,
    private _aswContextStoreSvc: AswContextStoreService
  ) {
    super(common);
  }

  override reload(): void {}
  override init(): void {
    this.backUrl = CHECKIN_ROUTES.standbyFlightAvailability;
  }

  /**
   * 戻るボタンが押下された場合イベント
   * @param event
   */
  onClickBackButton(event: Event) {
    // CPR情報取得結果のクリア
    this.cprResultStoreService.clearCprResult();
    // PNR情報取得結果のクリア
    this.getOrderResultStoreService.clear();
  }

  override destroy(): void {}
}
